import { createWebappRoute, getRouter } from '../helpers';

export default [
  // 'pricing': 'pricing',
  createWebappRoute({
    path: '/pricing',
    name: 'pricing-module',
    component() {
      console.log('ROUTER, pricing');

      if (DP.isProTrial() || DP.isFree() || DP.isFreemium()) {
        // toggle pricing modal after 500 milliseconds to ensure $dtLocationWizard.vwModal is loaded
        setTimeout(function() {
          $dt.vwDesktopContent.toggleOnBoardingPriceModal();
        }, 500);
      }

      getRouter().push({ name: 'home-module' });

      return {};
    },
  }),
];
